import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CedulaIdentidadRequest } from 'src/app/global/interfaces/cedula-identidad-request';
import { DatosPersonalesRequest } from 'src/app/global/interfaces/datos-personales-request';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { DatosPersonalesService } from 'src/app/global/services/datos-personales.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class DatosPersonalesProvider extends DatosPersonalesService {

  private api = environment.api;
  private endpoints = this.api.endpoints.PASO_2;

  constructor(private http: HttpClient) {
    super();
  }

  getDatosPersonales(): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.PERSONA;
    return this.http.get(endopoint);
  }

  registraDatosPersonales(datosPersonales: DatosPersonalesRequest): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.PERSONA;

    return this.http.post(endopoint, datosPersonales);
  }

  getNacionalidades(): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.NACIONALIDADES;
    return this.http.get(endopoint);
  }

  validaEdicion(): Observable<any> {
    const endopoint = this.api.host + this.api.path + this.endpoints.VALIDA_EDICION_2;
    return this.http.get(endopoint);
  }

  validaCi(run: number, ci: string, idEjecutivo: number,isMarketplaceSVA:boolean): Observable<GeneralResponse<any>> {
    const endopoint = this.api.host + this.api.path + this.endpoints.VALIDA_CI_PERSONA;
    idEjecutivo = idEjecutivo!= null ? Number(idEjecutivo) : null;
    const data: CedulaIdentidadRequest = {
      run,
      ci,
      idEjecutivo,
      marketplaceSVA:isMarketplaceSVA

    };
    // set header to let HTTP_INTERCEPTORS know to handle or not.
    return this.http.post<GeneralResponse<any>>(endopoint, data, { headers: { Anonymous: '' } });
  }

}
